/* eslint-disable react/prop-types */
import React from 'react'
import PasswordProtect from './password-protect'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const Customs = ({children, isDev}) => {
    const {rennaiRequirePass = false, rennaiEnvPassword = null} = getConfig()

    if (!isDev && (!rennaiRequirePass || !rennaiEnvPassword))
        return <>{children}</>
    return <PasswordProtect>{children}</PasswordProtect>
}

export default Customs
